// extracted by mini-css-extract-plugin
export default {"wrapperGallery":"DOzdN","photoWrapper":"v6lni","photo":"T1Dwx","cnPhoto":"uxPro","lastPhoto":"UVjAM","background":"oe794","countRest":"YEHEO"};